import React from "react";

import styles from "./firstTitle.module.scss";

const FirtsTitle = (props) => {
  const { color } = props;

  return (
    <h1 className={styles.firstTitle} style={{ color: color }}>
      {props.children}
    </h1>
  );
};

export default React.memo(FirtsTitle);
